import { LayoutType, PageLayout } from '../types/page';

export const parseEncodedJson = (json: string, paramName: string) => {
  try {
    return JSON.parse(decodeURIComponent(json));
  } catch (e) {
    console.warn(
      `Failed to parse ${paramName} query parameter. Make sure to run the code inside a supported Wix App extension.`,
      e,
    );
    return {};
  }
};

export const parsePageLayoutFromUrl = (
  queryParams: URLSearchParams,
): PageLayout => {
  const raw = queryParams.get('pageLayout');
  if (!raw) {
    return { type: LayoutType.Desktop };
  }
  const parsed: Partial<PageLayout> = parseEncodedJson(raw, 'pageLayout');
  return parsed.type ? (parsed as PageLayout) : { type: LayoutType.Desktop };
};
